<template>
  <div>
    <AttrInputNumber
      :value="shape.attrs['decimalOffsetX'] ?? 0"
      label="小数点偏移"
      addon-after="px"
      :min="-127"
      :max="127"
      :precision="0"
      :disabled="disabled"
      @change="onDecimalOffsetXChange"
    />
  </div>
</template>
<script lang="ts" setup>
import { Shape } from '@/services/shape';
import { PropType } from 'vue';

const props = defineProps({
  shape: {
    type: Object as PropType<Shape>,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  }
});

const onDecimalOffsetXChange = (val: number) => {
  props.shape.setAttrs({ decimalOffsetX: String(val) });
};
</script>
<style scoped></style>
